module.exports = __webpack_public_path__ + "media/images/black_history_month/arrow-left-458ecc79d0aacc3bb36033fae56db94c.svg";